// removed by extract-text-webpack-plugin
module.exports = {"relNotes-header":"relNotes-header","relNotes-title":"relNotes-title","relNotes-wrapper":"relNotes-wrapper","relNotes-bottom":"relNotes-bottom","relNotes-button-container":"relNotes-button-container","relNotes-button":"relNotes-button"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/relnotes/relnotes.scss
// module id = 4317
// module chunks = 1